import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = css`
  display: grid;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const variant = {
  small: (theme: Theme) => css`
    row-gap: ${theme.spacing[12]};
  `,
  medium: (theme: Theme) => css`
    row-gap: ${theme.spacing[16]};
  `,
};
